
const media = require('../components/utils/media');

const selectors = {
    buttonAddToCart: '.js-add-to-cart',
    isMasterProduct: '.js-product_ismaster',
    colorAlert: '.js-variation-color-alert',
    sizeAlert: '.js-variation-size-alert',
    stockAlert: '.js-stock-error',
    buttonAddToBabyRegistry: '.js-add-to-registry, .js-add-to-registry-warn'
};

module.exports = {

    updateAttributesAndDetails() {
        $('body').on('product:statusUpdate', (e, data) => {
            const $productAttributeElements = $('.js-product-detail').find('[data-attribute]');

            //Update product attributes data elements and togle its visibility
            $productAttributeElements.each((index, element) => {
                const attributeBinding = $(element).data('attribute');
                const attributeValue = data[attributeBinding];

                $(element).text(attributeValue);
                $(element).closest('.js-attribute_container').toggleClass('h-hidden', !attributeValue);
            });
        });
    },
    updateAttribute() {
        $('body').on('product:afterAttributeSelect', (e, response) => {
            if ($('.product-set-detail').eq(0)) {
                response.container.data('pid', response.data.product.id);
                response.container.find('.product-id').each((index, element) => {
                    var $element = $(element);
                    if (!$element.hasClass('js-recommended')) {
                        $(element).text(response.data.product.id);
                    }
                });
            } else {
                $('.product-id').text(response.data.product.id);
                $('.js-product-detail:not(".bundle-item")').data('pid', response.data.product.id);
            }
        });
    },
    updateAddToCart() {
        // eslint-disable-next-line complexity
        $('body').on('product:updateAddToCart', (e, response) => {
            let isAvailableForInStorePickup, isAvailable, isContactStoreError;
            if (response) {
                isAvailableForInStorePickup = response.product.isAvailableForInStorePickup;
                isAvailable = response.product.available;
                isContactStoreError = response.product.isContactStoreError;

                let availability = response.product.availability;
                if (availability.type === 'preorder' && availability.restrictionsEnabled) {
                    $('.js-pre-order-restriction-error').removeClass('h-hidden');
                }
            } else {
                // Init from data attributes
                const $shippingInfoContainer = $('.js-shipping-info');
                isAvailableForInStorePickup = !!$shippingInfoContainer.data('availableforinstorepickup');
                isContactStoreError = !!$shippingInfoContainer.data('contactstoreerror');
                const $availabilityContainer = $('.js-product-availability_container').find('.product-availability');
                isAvailable = !!$availabilityContainer.data('available');
            }
            // update local add to cart (for sets)
            let storeId = $('.js-selected-store-with-inventory').data('store-id');

            const enable = $('.js-product-availability')
                .toArray().every(item => $(item).data('available') && $(item).data('ready-to-order'));
            $('button.add-to-cart-global').attr('disabled', !enable);
            $('button.js-add-to-cart-buy-with.js-is-buy-with').attr('disabled', !enable);
            // Display/Hide Empty Store error
            $('.js-emptystore-error').toggleClass('h-hidden',
                isAvailable || !isAvailableForInStorePickup || storeId !== '');

            // Display/Hide Contact Store error
            isContactStoreError || !isAvailableForInStorePickup ? $('.js-contactstore-error').removeClass('h-hidden') : $('.js-contactstore-error').addClass('h-hidden');
            // Remove error messages
            $(selectors.stockAlert)
                .addClass('m-hidden')
                .empty();
        });
    },
    updateAvailability() {
        $('body').on('product:updateAvailability', (e, response) => {
            var $availabilityBlock = $('.js-product-availability_container');

            if (response.product.availabilityMarkup) {
                $availabilityBlock.html(response.product.availabilityMarkup);
            }

            const $isAvailableInPreferredStore = $('.js-shipping-info').data('availabilityinpreferredstore');
            const isAvailableForInStorePickup = $('.js-shipping-info').data('availableforinstorepickup');
            const isComingSoon = $('.js-shipping-info').data('comingsoon');
            const isComingSoonAvailable = $('.js-shipping-info').data('comingsoonavailable');

            var $selectedStore = $('.js-selected-store-with-inventory');
            var selectedStoreInfo = {
                ID: $selectedStore.attr('data-store-id'),
                name: $('.js-selected-store').text()
            }

            var $preferredStore = $('.js-selected-my-home-store');
            var preferredStoreInfo = JSON.parse($preferredStore.attr('data-store-info'));

            if (selectedStoreInfo.ID && selectedStoreInfo.name && preferredStoreInfo) {
                if ($isAvailableInPreferredStore && isAvailableForInStorePickup && !(isComingSoon && !isComingSoonAvailable)) {
                    $('.js-ISPU').removeClass('m-disabled');
                    $('.js-preferred-store-error').addClass('h-hidden');
                    $('.js-contactstore-error').addClass('h-hidden');
                    if ($('.js-contactstore-instock').length) {
                        let preferredStoreAvailable = $('.js-contactstore-instock').text().replace('#', selectedStoreInfo.name);
                        $('.js-contactstore-instock').text(preferredStoreAvailable);
                        $('.js-contactstore-instock').removeClass('h-hidden');
                    }
                } else if (!$isAvailableInPreferredStore && selectedStoreInfo.ID && isAvailableForInStorePickup) {
                    let preferredStoreError = $('.js-preferred-store').text().replace(preferredStoreInfo.name, selectedStoreInfo.name);
                    $('.js-preferred-store').text(preferredStoreError);
                    $('.js-ISPU').addClass('m-disabled');
                    $('.js-contactstore-error').addClass('h-hidden');
                    $('.js-preferred-store-error').removeClass('h-hidden');
                    if ($('.js-contactstore-instock').length) {
                        $('.js-contactstore-instock').addClass('h-hidden');
                    }
                } else if (!isAvailableForInStorePickup) {
                    let itemNotInStore = $('.js-contactstore-error').text().replace('#', selectedStoreInfo.name);
                    $('.js-contactstore-error').text(itemNotInStore);
                    $('.js-ISPU').addClass('m-disabled');
                    $('.js-preferred-store-error').addClass('h-hidden');
                    $('.js-contactstore-error').removeClass('h-hidden');
                    if ($('.js-contactstore-instock').length) {
                        $('.js-contactstore-instock').addClass('h-hidden');
                    }
                }
            } else if (selectedStoreInfo.ID && !(isComingSoon && !isComingSoonAvailable)) {
                $('.js-ISPU').removeClass('m-disabled');
            }
        });
    },
    showSpinner() {
        $('body').on('product:beforeAddToCart product:beforeAttributeSelect', () => {
            // custom action run before adding to cart
        });
    },
    handleAddToBabyRegistry() {
        $('.js-add-to-baby-pdp > .js-add-to-registry').on('click', function (e) {
            e.preventDefault();

            var $buttonAddToBabyRegistry = $(this);
            var $colorVariantSelector = $('.js-color-button');
            var $sizeVariantSelector = $('.js-size-options');

            var disableButton = false;
            if ($buttonAddToBabyRegistry.data('isMaster') || $buttonAddToBabyRegistry.data('isVariant')) {
                if ($colorVariantSelector.length > 0 && !$colorVariantSelector.hasClass('m-selected')) {
                    $(selectors.colorAlert).removeClass(window.styleConstants.hideClass);
                    disableButton = true;
                } else {
                    if (!$(selectors.colorAlert).hasClass(window.styleConstants.hideClass)) {
                        $(selectors.colorAlert).addClass(window.styleConstants.hideClass);
                    }
                }
        
                if ($sizeVariantSelector.length > 0 && $('.js-size-options:selected').length === 0) {
                    $(selectors.sizeAlert).removeClass(window.styleConstants.hideClass);
                    disableButton = true;
                } else {
                    if (!$(selectors.sizeAlert).hasClass(window.styleConstants.hideClass)) {
                        $(selectors.sizeAlert).addClass(window.styleConstants.hideClass);
                    }
                }
            }

            $buttonAddToBabyRegistry.prop('disabled', disableButton);
        });
    },
    storeSelected() {
        $('body').on('store:selected', () => {
            $(selectors.buttonAddToCart)
                .removeClass(selectors.masterProduct);
        });
    },
    storeSelectionRemoved() {
        $('body').on('store:cleared', () => {
            $(selectors.buttonAddToCart)
                .attr('disabled', true)
                .addClass(selectors.masterProduct);
        });
    },
    pdpStickyFooter() {
        if (media.getBreakpoint() !== 'small') {
            $(document).scroll(() => {
                var scroll = $(document).scrollTop();
                let isProductPage = $('.js-pdp-container').length > 0;
                if (isProductPage) {
                    if ($('.b-product_details-shipping-container').length) {
                        let shippingBlockPosition = $('.b-product_details-shipping-container').offset().top;
                        $('.js-sticky-footer').toggleClass('m-visible', scroll > shippingBlockPosition);
                    }
                }
            });
        }
    },
    pdpStickyFooterClose() {
        $('.js-sticky-footer').on('click', '.js-close-sticky-footer', (e) => {
            e.preventDefault();
            $('.js-sticky-footer').addClass('m-closed');
        });
    },
    /**
     * Updates the size attribute on a product detail page
     * @returns {void}
     */
    pdpSizeUpdateAttribute() {
        setTimeout(function () {
            var selectSizeElement = $('.js-m-select_size');
            if (selectSizeElement.length > 0 && selectSizeElement.val() === null) {
                selectSizeElement.val(selectSizeElement.find('option:first').val());
            }
        }, 100);
    }
};
